import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card } from 'antd';
import { useTranslation } from 'react-i18next';
import { httpsCallable } from 'firebase/functions'; // Asegúrate de importar esto si estás usando Firebase
import { auth, functions } from '../../firebase';
import './contactForm.css';

const ContactForm = () => {
  const { t, i18n } = useTranslation(); // Initialize translation hook
  const [form] = Form.useForm();

  const sendContactMail = async (name, email, message) => {
    try {
      console.log("MANDANDO MAIL DE CONTACTO");
      const sendContactEmail = httpsCallable(functions, 'sendWelcomeEmail');

      // Plantilla HTML del correo
      const htmlContent = `
        <!DOCTYPE html>
        <html>
        <head>
            <title>Nuevo mensaje de contacto</title>
            <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1">
            <meta http-equiv="X-UA-Compatible" content="IE=edge" />
            <style type="text/css">
                body { font-family: 'Lato', Helvetica, Arial, sans-serif; }
                .container { padding: 20px; background-color: #f4f4f4; }
                h1 { color: #394655; }
                p { color: #666666; }
            </style>
        </head>
        <body>
            <div class="container">
                <h1>Nuevo Mensaje de Contacto</h1>
                <p><strong>Nombre:</strong> ${name}</p>
                <p><strong>Email:</strong> ${email}</p>
                <p><strong>Mensaje:</strong></p>
                <p>${message}</p>
            </div>
        </body>
        </html>
      `;

      const result = await sendContactEmail({
        to: 'reveatpro@gmail.com', // Correo del equipo de soporte
        subject: `Nuevo mensaje de contacto de ${name}`,
        text: `Nuevo mensaje de contacto de ${name}. Email: ${email}. Mensaje: ${message}`,
        html: htmlContent
      });

      console.log('Email enviado:', result.data);
    } catch (error) {
      console.error('Error al enviar el email:', error);
    }
  };

  useEffect(() => {
    const allErrors = form.getFieldsError();
    const fieldsWithErrors = allErrors.filter(({ errors }) => errors.length > 0);

    if (fieldsWithErrors.length > 0) {
        const fieldsToValidate = fieldsWithErrors.map(({ name }) => name[0]);
        form.validateFields(fieldsToValidate);
    }
  }, [i18n.language]);

  const onFinish = async (values) => {
    // Captura los valores de los campos del formulario
    const { name, email, message } = values;

    // Llama a la función para enviar el correo
    await sendContactMail(name, email, message);

    // Opcional: Limpiar el formulario o mostrar un mensaje de éxito
    alert('Tu mensaje ha sido enviado con éxito.'); // Mensaje de éxito
  };

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const isMobile = windowSize.width <= 768;

  return (
    <Card title={t('contactForm.title')} className='card contactFormCard' style={{ maxWidth: 600, margin: '0 auto', marginTop: isMobile ? 15 : 60 }}>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="name"
          label={t('contactForm.nameLabel')}
          rules={[{ required: true, message: t('contactForm.nameError') }]}
        >
          <Input placeholder={t('contactForm.namePlaceholder')} />
        </Form.Item>
        <Form.Item
          name="email"
          label={t('contactForm.emailLabel')}
          rules={[
            { required: true, message: t('contactForm.emailError') },
            { type: 'email', message: t('contactForm.emailInvalid') },
          ]}
        >
          <Input placeholder={t('contactForm.emailPlaceholder')} />
        </Form.Item>
        <Form.Item
          name="message"
          label={t('contactForm.messageLabel')}
          rules={[{ required: true, message: t('contactForm.messageError') }]}
        >
          <Input.TextArea rows={4} placeholder={t('contactForm.messagePlaceholder')} />
        </Form.Item>
        <Form.Item className='submit-wrapper'>
          <Button type="primary" htmlType="submit">
            {t('contactForm.submitButton')}
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default ContactForm;
